import { v4 } from 'uuid';
import * as cookie from './cookie';

const UNDEFINED = -1;

export const initialize = () => {
  cookie.setCookie('purchases.watermark', v4());
  cookie.setCookie('purchases.seq', new Date().getTime());
  cookie.setCookie('purchases.finishedStep', UNDEFINED);
};

export const watermark = (): string => cookie.getCookie('purchases.watermark')!;

export const finalize = (step: number) => {
  cookie.setCookie('purchases.watermark', '');
  cookie.setCookie('purchases.finishedStep', step);
};

export const setSeq = (sequential: number) => {
  cookie.setCookie('purchases.seq', sequential);
};

export const seq = (): number =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  parseInt(cookie.getCookie('purchases.seq', seq)!, 10);

export const finishedStep = (): number | undefined => {
  const step = parseInt(cookie.getCookie('purchases.finishedStep')!, 10);
  return step === UNDEFINED ? undefined : step;
};
